/**
 * Working records for one delete or merge operation (OWA-830 review, CXR-2-001 / CXR-2-002 / CXR-4-001).
 *
 * A save queued through `save<X>Queue` is not visible in Redux until its saga has written IndexedDB
 * and emitted `<X>_SAVE`. Every generated dependency block, every successive `replace<X>` call in a
 * multi-select merge, and every `delete<X>` call in a bulk Delete All would otherwise read the same
 * stale record and queue a full-record save that overwrites the earlier ones. Blocks instead read the
 * latest working version of a record from here, apply their change on top of it, and write it back
 * before queueing, so the last queued version of each record carries every change of the operation.
 *
 * The operation is the current synchronous burst of work: merge dialogs, single deletes, and the
 * bulk-delete loop all call the generated functions without yielding, so one set is shared by
 * everything that runs before the next microtask and is released there. Keying on an id supplied by
 * each caller was tried and missed the bulk-delete path, whose callers pass none.
 */
let current: Map<string, unknown> | null = null;

export function workingSet(): Map<string, unknown> {
    if (!current) {
        const set = new Map<string, unknown>();
        current = set;
        queueMicrotask(() => {
            if (current === set) current = null;
        });
    }
    return current;
}
